import styles from "./BasicInfo.module.css";
import React from 'react'; // useState 제거됨
import { useParams } from 'react-router-dom';
import ImageLightMicroscope from "./ImageLightMicroscope";
import ImagePathologyPicture from "./ImagePathologyPicture";
import Graph from "./Graph";
import EditBasicInfoModal from "./EditBasicInfoModal";
import { useTranslation } from 'react-i18next';

// components
import OrganoidInfoTab from "./OrganoidInfoTab";
import PatientInfoTab from "./PatientInfoTab";
import ImageComponent from "../../components/ImageComponent";
import DrugResponsePage from "../../components/graphComponents/DrugResponsePage";

// 모달창
import Button from 'react-bootstrap/Button';

// [수정 핵심] props 구조 분해 할당을 통해 상위 컴포넌트에서 전달한 setGraphImage를 받아옵니다.
function BasicInfo({ setGraphImage }) {
    const { t } = useTranslation();
    const { tmpKey } = useParams();

    function hashMark(str) {
        return (String(str).replace('hashmark', '#'));
    }

    // 기존의 fetch 부분은 OrganoidInfoTab 등 하위 컴포넌트에서 
    // 개별적으로 처리하고 있는 것으로 보여 주석을 깔끔하게 제거했습니다.

    return (
        <div className={styles.rightTabBox}>
            <div className={styles.twoPartBox}>
                <OrganoidInfoTab />
                <PatientInfoTab />
            </div>
            <div className={styles.titleOutBox}>
                <div className={styles.title}>
                    Image
                </div>
            </div>
            <div className={styles.twoPartBox}>
                <ImageComponent type='Image' />
                <ImageComponent type='Histology' />
            </div>
            <div className={styles.titleOutBox}>
                <div className={styles.title}>
                    Drug Response
                </div>
            </div>
            <div className={styles.graphBox}>
                {/* [수정 핵심] 전달받은 setGraphImage를 최하위 그래프 컴포넌트로 다시 넘겨줍니다. */}
                <DrugResponsePage setGraphImage={setGraphImage} />
            </div>
        </div>
    );
}

export default BasicInfo;